"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var models_1 = require("../../models");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var services_1 = require("../../services");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var material_1 = require("@angular/material");
var sis_table_settings_component_1 = require("./sis-table-settings.component");
var sis_table_builder_component_1 = require("./sis-table-builder.component");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
require("./sis-table.component.scss");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var lodash_1 = require("lodash");
var SisTable = /** @class */ (function (_super) {
    __extends(SisTable, _super);
    function SisTable(kbService, currentLanguageProvider, deService, extractionService, validationService, dialog) {
        var _this = _super.call(this) || this;
        _this.kbService = kbService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.deService = deService;
        _this.extractionService = extractionService;
        _this.validationService = validationService;
        _this.dialog = dialog;
        _this.messageId = 'de_add';
        // Expose enums to use in template.
        _this.metaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        _this.isActionMenuOpened = false;
        _this.selectedRow = null;
        _this.selectedActionType = '';
        return _this;
    }
    SisTable.prototype.ngOnInit = function () {
        var _this = this;
        var kbData$ = this.kbService.getMetaFields(this.categoryName);
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        var requiredMetaFields$ = this.validationService.getCategoryRequiredMetaFieldIds(this.categoryName);
        zip_1.zip(kbData$, currentLanguage$, requiredMetaFields$)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.digOutColumnsMetaFields(data[0]);
            _this.handleColumnAlignments();
            _this.currentLanguage = data[1];
            _this.handleHeader(data[2]);
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    SisTable.prototype.handleColumnAlignments = function () {
        var _this = this;
        if (this.columnMetaFields) {
            this.columnMetaFields.forEach(function (col) {
                _this.handleAlignments(col, _this.perColumnAlignment);
            });
        }
    };
    SisTable.prototype.openAddPopup = function () {
        var _this = this;
        this.deService
            .createBlankSubEntity(this.categoryName)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (subEntity) {
            subEntity.setId(_this.getUniqueIdForSubEntity());
            _this.actions.openPopup(_this.form, _this.categoryName, _this.subFormKey, subEntity, _this.formId);
        }, function (err) { return console.error(err); });
    };
    SisTable.prototype.inlineAdd = function () {
        var _this = this;
        this.deService
            .createBlankSubEntity(this.categoryName)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (subEntity) {
            subEntity.setId(_this.getUniqueIdForSubEntity());
            _this.rowItems.push(subEntity);
        }, function (err) { return console.error(err); });
    };
    SisTable.prototype.openEditPopup = function (rowItem) {
        var _this = this;
        this.deService
            .createBlankSubEntity(this.categoryName)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (subEntity) {
            _this._allMetaFields.forEach(function (metaField) {
                subEntity.getProperty(metaField.getSystemName()).value = rowItem.getProperty(metaField.getSystemName()).value;
            });
            _this.actions.openEditPopup(_this.form, _this.categoryName, _this.subFormKey, subEntity, _this.formId);
        }, function (error) { return console.error(error); });
    };
    SisTable.prototype.getCellWithPercentage = function (index) {
        if (this.cellCounts && this.cellCounts.length > index) {
            return (this.cellCounts[index] / 12) * 100;
        }
        return 33;
    };
    SisTable.prototype.isViewForm = function () {
        return this.formType === idm_dynamic_layout_interpreter_1.FormType.VIEW;
    };
    SisTable.prototype.isEditForm = function () {
        return this.formType === idm_dynamic_layout_interpreter_1.FormType.EDIT;
    };
    SisTable.prototype.getColContent = function (rowItem, metaField) {
        var languageId = this.currentLanguage.getId();
        var compoundCategoryName = metaField.getCompoundCategorySystemName();
        if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
            return of_1.of(rowItem
                .getProperty(metaField.getSystemName())
                .value.getValue(languageId));
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
            return this.extractionService.extractNameFromClassifierCached(rowItem.getProperty(metaField.getSystemName())
                .value, compoundCategoryName, languageId);
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT) {
            return this.extractionService.extractNameFromMultiSelectCached(rowItem.getProperty(metaField.getSystemName())
                .value, compoundCategoryName, languageId);
        }
        else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY) {
            return this.extractionService.extractNameFromEntityCached(rowItem.getProperty(metaField.getSystemName()).value, compoundCategoryName, languageId);
        }
        return of_1.of(rowItem.getProperty(metaField.getSystemName()).value);
    };
    SisTable.prototype.trackByRowItemsIds = function (index, rowItem) {
        return rowItem.getId();
    };
    SisTable.prototype.trackByMetaFieldsIds = function (index, columnMetaField) {
        return columnMetaField.getMetaFieldId().getSystemName();
    };
    SisTable.prototype.isNil = function (value) {
        return lodash_1.isNil(value);
    };
    SisTable.prototype.digOutColumnsMetaFields = function (metaFields) {
        this._allMetaFields = metaFields;
        this.columnMetaFields = [];
        if (this.colSystemNames) {
            this.columnMetaFields = this.colSystemNames.map(function (colName) {
                return metaFields.find(function (meta) {
                    return meta.getSystemName().toLowerCase() ==
                        colName.toLowerCase();
                });
            });
        }
    };
    SisTable.prototype.selectRow = function (row, buttonType) {
        this.selectedRow = row;
        this.selectedActionType = buttonType;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTable.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisTable.prototype, "rowItems", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTable.prototype, "actions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisTable.prototype, "isDeletable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisTable.prototype, "isAddable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisTable.prototype, "colSystemNames", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisTable.prototype, "cellCounts", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTable.prototype, "subFormKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisTable.prototype, "formId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTable.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTable.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisTable.prototype, "formType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisTable.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTable.prototype, "fieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTable.prototype, "mainCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTable.prototype, "perColumnAlignment", void 0);
    SisTable = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-table',
            template: require('./sis-table.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <sis-table [id]=\"'%{id}'\" [categoryName]=\"'%{field-category}'\" [actions]=\"actions\" [form]=\"form\"\n                   [fieldName]=\"'%{field-name}'\" [mainCategory]=\"category\"\n                   [subFormKey]=\"%{subFormKey}\" [colSystemNames]=\"%{colSystemNames}\" [formType]=\"formType\"\n                   [cellCounts]=\"%{cellCounts}\" [formId]=\"%{formId}\" [isReadonly]=\"%{isReadonly}\"\n                   [isDeletable]=\"%{isDeletable}\" [isAddable]=\"%{isAddable}\" [rowItems]=\"%{field}\">\n        </sis-table>\n    ",
            cellCount: 12,
            settings: {
                main: sis_table_settings_component_1.SisTableSettings,
                central: sis_table_builder_component_1.SisTableBuilder,
            },
            groups: [{ identity: 'input', name: 'Input Elements' }],
            iconInfo: 'fa-dot-circle-o',
            name: 'Table',
            nameKey: 'de.controls.table.title',
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_de_service_client_js_1.DeService,
            services_1.ExtractionService,
            idm_validation_calculation_service_client_js_1.ValidationService,
            material_1.MatDialog])
    ], SisTable);
    return SisTable;
}(models_1.BaseTable));
exports.SisTable = SisTable;
//# sourceMappingURL=sis-table.component.js.map